import * as React from 'react';
import { PageProps, withPageProps } from '../components/Page'
import * as Styles from '@material-ui/core/styles';
import * as Model from '../models'
import * as HokanApi from '../api/hokan'
import Loading from '../components/Loading'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
//import SubTitle from '../components/SubTitle'
import * as Colors from '../components/Colors'
import { withStyles } from '@material-ui/core/styles';
import { Patient } from '../models/Patient'
import * as Icons from '@material-ui/icons';
import Button from '@material-ui/core/Button';
import { Paper, Tabs, Tab, Select, MenuItem, Grid } from '@material-ui/core';
import DateUtil from '../util/DateUtil'
import StandardTable from '../components/StandardTable';
import Col2Table from '../components/Col2Table';
import TalkList from '../components/TalkList';
import { StoreAccessor } from '../util/StoreUtil';
import Firebase from '../firebase'
import { saveAs } from 'file-saver';
import Encoding from 'encoding-japanese';
import PatientSelectDialog from '../components/PatientSelectDialog';

const styles = () => Styles.createStyles({
    root: {
        margin: "10px",
        maxWidth: "2000px",
        marginLeft: "auto",
        marginRight: "auto",
        padding: "10px"
    },
    table: {
        marginBottom: "20px",
        color: Colors.primaryColor,
        fontSize: "0.9rem",
        transition: "linear 0.2s",
    },
    tableHead: {
        background: Colors.primaryColor,

    },
    row: {
        border: "solid",
        marginTop: "-1px",
        borderColor: "#e0e0e0",
        borderWidth: "1px",
        borderLeft: "none",
        borderRight: "none",
        cursor: "pointer",
        '&:nth-of-type(odd)': {
            backgroundColor: Colors.backColor
        },
        "&:last-child": {


        },
        "&:hover": {
            backgroundColor: Colors.borderColorTransparent,
            outlineStyle: "solid",
            outlineWidth: "1px",
            outlineColor: Colors.primaryColor,
            border: "none",

        }
    },
    itemIcon: {
        "& svg": {
            fontSize: "15px"
        }
    }
})

interface Props extends PageProps, Styles.WithStyles {
}

interface LocalState {
    branches: Model.Branch[]
    patients: Model.Patient.Patient[]
    loading: boolean
    branch_id: number | null
    me: Model.User,
}

class EigyouPage extends React.Component<Props, LocalState> {
    displayName = "EigyouPage"
    constructor(props: Props) {
        super(props)
        let index = 0;
        if (props.location.hash == "#new") {
            index = 1
        }
        else if (props.location.hash == "#thread") {
            index = 3
        }


        this.state = {
            patients: [],
            loading: true,
            branches: [],
            branch_id: null,
            me: new Model.User()
        }
    }

    public componentDidMount = () => {
        HokanApi.branch.list()
            .then(x => {
                return x.data
            })
            .then(branch_list => {
                HokanApi.me().then(x => {
                    const b = x.data.branch_id
                    const me = x.data
                    this.setState({ branch_id: b, me: me, branches: branch_list.concat({ id: 0, name: "全事業所" } as Model.Branch) })
                    this.loadBranch(b)
                })
                    .catch(err => {
                        console.log(err)
                    })
            })
            .catch(err => {
                console.log(err)
            })
    }

    private loadBranch = (branchId) => {
        this.setState({
            loading: true,
            branch_id: branchId,
        })
        HokanApi.getPatientsEigyou(branchId)
            .then(async x => {
                const patients = x.data.map(
                    y => Model.Patient.Patient.load(y, false)
                ).sort((a, b) => {
                    const shoukaiA = a.basic.shoukai_from || new Model.OrganizationTanto()
                    const shoukaiB = b.basic.shoukai_from || new Model.OrganizationTanto()
                    const av = shoukaiA.org.name
                    const bv = shoukaiB.org.name
                    const av2 = a.created_at
                    const bv2 = b.created_at
                    if (av == bv) return (av2 < bv2 ? -1 : 1)
                    if (av > bv) return 1
                    return -1
                })
                console.log(patients)
                this.setState({
                    patients: patients,
                    loading: false
                })
            })
            .catch(err => {
                console.log(err)
                this.setState({ loading: false })
            })
    }

    private csvExpoter() {
        const data = this.state.patients
        const csvData: string | null = (() => {
            const headers = ["紹介元", "紹介日", "状況",   
                "紹介者", "紹介者役職",           
                "事業所", "基本となる保険", "利用者", 
                "郵便番号", "都道府県", "市区町村"
            ]
            let result = headers.join(",") + '\n'

            data.forEach(patient => {
                const shoukai = patient.basic.shoukai_from || new Model.OrganizationTanto()
                const row =
                    [
                        shoukai.org.name,
                        DateUtil.toSlashDateStringShort(patient.created_at),
                        (patient.is_canseled ? "キャンセル済" :
                        patient.is_shinki ?  "検討中" : "受入済"),
                        shoukai.name,
                        shoukai.role,
                        patient.branch.name,
                        patient.hoken.hoken_type,
                        patient.name,
                        patient.env.address_zip,
                        `"${patient.env.address1}"`,
                        `"${patient.env.address2}"`
                    ]
                result += row.join(",") + "\n"
            })
            return result
        })()

        const onCsvExportButtonClick = () => {
            const str = Encoding.stringToCode(csvData);
            const convert = Encoding.convert(str, 'sjis', 'unicode');
            const u8a = new Uint8Array(convert);

            const blob = new Blob([u8a], { type: 'text/csv;charset=Shift_JIS;' });
            saveAs(blob, `営業情報.csv`);
        }


        return <div>
            {csvData && 
            <Button type="button" variant='contained' 
            onClick={onCsvExportButtonClick} style={{}}
            disabled={this.state.loading}
            >ダウンロード</Button>}
        </div>
    }


    public render() {
        const { classes, history } = this.props;
        const { loading } = this.state;
        const saQ = new StoreAccessor(this, true, "query")

        const element_l = [
            {
                name: "事業所", content: <div>
                    <Select
                        value={this.state.branch_id || '0'}
                        autoWidth={true}
                        variant='outlined'
                        onChange={(e) => this.loadBranch(e.target.value)}
                        className={classes.input}
                    >
                        {
                            this.state.branches.map((t, idx) =>
                                <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>
                            )
                        }
                    </Select>
                </div>
            },
            {
                name: "CSV 書き出し",
                content: <div>
                    {this.csvExpoter()}
                 </div>
            }
        ]

        return (
            <div className={classes.root}>
                <div style={{ display: "block", width: "100%" }}>
                    <StandardTable title=''>
                        <Grid container={true} spacing={0}>
                            <Grid item={true} xs={12} md={12} lg={12}>
                                <Col2Table body={element_l} />
                            </Grid>
                        </Grid>
                    </StandardTable>
                </div>
            </div>
        );
    }
}

export default withPageProps(Styles.withStyles(styles)(EigyouPage))
